export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
// module chunks = 18